<pu-multi-select-search
  multipleMode
  [controlId]="controlId()"
  [formControl]="control()"
  [items]="channels()"
  [label]="label() | translate"
  [outputFormat]="outputFormat()"
>
  <ng-template #itemTpl let-item>
    <div class="pt-slack-channel-dropdown__channel-item">
      <span class="pt-slack-channel-dropdown__channel-item-name">
        {{ item.name }}
      </span>

      @if (item.workspace) {
        <div class="pt-slack-channel-dropdown__channel-workspace">
          <div
            class="pt-slack-channel-dropdown__channel-workspace-color-dot"
            [ngStyle]="{'background-color': getWorkspaceColor(item.workspace)}"
          >
          </div>

          <div class="pt-slack-channel-dropdown__channel-workspace-name">
            {{ item.workspace }}
          </div>
        </div>
      }
    </div>
  </ng-template>
</pu-multi-select-search>
